import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import * as colors from "../../../assets/css/Colors";
import { Link } from "react-router-dom";

// 
import Location from '../../../modal/Location';


const Index = () => {
    const [pincode, setPincode] = useState('');
    const [error, setError] = useState(null);
  
    const handleLocationUpdate = async (updatedLocation) => {
      try {
        const pincodeMatch = updatedLocation.match(/\b\d{6}\b/);
        const newPincode = pincodeMatch ? pincodeMatch[0] : '';
        setPincode(newPincode);
      } catch (error) {
        setError(error.message);
      }
    };

  // Start color change auto function
  const [colorScheme, setColorScheme] = useState(
    window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  );
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      setColorScheme(e.matches ? 'dark' : 'light');
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);
  // End color change auto function
  //  gradient color Start
  const styles = {
    background: colorScheme === 'dark'
      ? `linear-gradient(to right, ${colors.theme_black_color}, ${colors.theme_black_color}, ${colors.theme_white_color})`
      : `linear-gradient(to right, ${colors.theme_white_color}, ${colors.theme_white_color}, ${colors.theme_black_color})`,
  };
  const boxstyle = {
    backgroundColor: colorScheme === 'dark' ? colors.theme_black_color_bg : colors.theme_white_color_bg,
    border: `1px solid ${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}`,
  }
  const boxstyleqrcode = {
    border: `2px solid ${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}`,
    borderRadius: '8px',
  };
  // gradient color End
  return (
    <>
    <section className='section'>
  <div className='loctionbuttonhide'>
  <Location onLocationUpdate={handleLocationUpdate}/>
  </div>
  <Container>
    <Row>
      <Col sm={12}>
        <div className="home-tit">
          <h2><span> Detailed Information on Local </span> <form onSubmit={(e) => e.preventDefault()}>
            <input
              type="text" className='popuple-data-count-pincode' style={boxstyleqrcode}
              value={pincode}
              onChange={(e) => setPincode(e.target.value)}
              placeholder="Pincode"
            />
          </form><span>&nbsp;Area </span></h2>
          <p>Which local area's information would you like to know? Enter the pincode of that local area where a pincode (6 digits) is already available.</p>
          <p>Get comprehensive details about local schools and colleges, including information on students and teachers, with a breakdown by gender.</p>
        </div>
        <div className="ad-dash-s4">
          <Row>
            <Col sm={3}>
              <div className="cor-1 females" style={boxstyle}>
                <h2>Female</h2>
                <span>1</span>
                <p>With the help of this Card, you will know number of females in your local area.</p>
                <span className="cor-4 females"></span>
              </div>
            </Col>
            <Col sm={3}>
              <div className="cor-1 males" style={boxstyle}>
                <h2>Male</h2>
                <span>1</span>
                <p>With the help of this Card you will know number of males in your local area.</p>
                <span className="cor-4 males"></span>
              </div>
            </Col>
            <Col sm={3}>
            <div className="cor-1 Student males_females" style={boxstyle}>
                <h2>Student</h2>
                <span>1</span>
                <p>With the help of this Card, you will know number of students in your local area.</p>
                <span className="cor-4 Student males_females"></span>
              </div>
            </Col>
            <Col sm={3}>
            <div className="cor-1 Teacher males_females" style={boxstyle}>
                <h2>Teacher</h2>
                <span>1</span>
                <p>With the help of this Card, you will know number of teachers in your local area.</p>
                <span className="cor-4 Teacher males_females"></span>
              </div>
            </Col>
            <Col sm={3}>
              <div className="cor-1 females" style={boxstyle}>
                <h2>Government Schools</h2>
                <span>1</span>
                <p>With the help of this Card, you will know number of Government Schools.</p>
                <span className="cor-4 females"></span>
              </div>
            </Col>
            <Col sm={3}>
              <div className="cor-1 males" style={boxstyle}>
                <h2>Private Schools</h2>
                <span>1</span>
                <p>With the help of this Card you will know number of Private Schools.</p>
                <span className="cor-4 males"></span>
              </div>
            </Col>
            <Col sm={3}>
            <div className="cor-1 Student males_females" style={boxstyle}>
                <h2>Government Colleges</h2>
                <span>1</span>
                <p>With the help of this Card, you will know number of Government Colleges.</p>
                <span className="cor-4 Student males_females"></span>
              </div>
            </Col>
            <Col sm={3}>
            <div className="cor-1 Teacher males_females" style={boxstyle}>
                <h2>Private Colleges</h2>
                <span>1</span>
                <p>With the help of this Card, you will know number of Private Colleges.</p>
                <span className="cor-4 Teacher males_females"></span>
              </div>
            </Col>
          </Row>
      
        </div>
        <div className='view-more-button'>
          <Link to="/Card">
            <span className="btn-ser-need-ani Add-Any-Equation" style={{ backgroundColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>More Information of Your Local Area</span>
          </Link>
        </div>
      </Col>
    </Row>
  </Container>
  </section>
      </>
  )
}

export default Index